<template>
  <div class="container">
    <div class="row top5">
      <div class="col-lg-3"><BrandFilter></BrandFilter></div>
      <div class="col-lg-9">
        <div class="row">
          <div class="col-sm-8">
            <b-input-group>
              <b-form-input
                class="LoginInput"
                size="sm"
                placeholder="Search phone"
                v-model="searchText"
                @keyup="search()"
              >
              </b-form-input>
              <b-input-group-prepend>
                <span class="input-group-text"
                  ><font-awesome-icon icon="search" @click="search()"
                /></span>
              </b-input-group-prepend>
            </b-input-group>
          </div>
          <div class="col-sm-4">
            Sort By
            <select name="sortBy" @change="onChange($event)">
              <option
                v-for="x in sortBy"
                v-bind:value="x.value"
                v-bind:selected="x.selected"
                v-bind:key="x.id"
                >{{ x.text }}</option
              >
            </select>
          </div>
        </div>
        <div class="row top5">
          <div
            class="col-6 col-sm-4 col-md-6 mb-4 col-lg-4"
            v-for="product in filterProducts"
            :key="product.id"
          >
            <div class="card h-90 product">
              <!-- www.thepolyglotdeveloper.com/2017/11/pass-data-between-routes-vuejs-web-application/ -->
              <router-link
                class="product__link"
                :to="{ name: 'Product', params: { id: product.id } }"
              >
                <div class="product__imgContainer">
                  <img
                    :src="product.images[0]"
                    class="card-img-top product__img"
                  />
                </div>
              </router-link>

              <div class="card-body product__text">
                <h4 class="card-title product__title">
                  {{ product.title }}
                </h4>
                <h5 class="product__price">
                  {{ product.price | priceFormatter }}
                </h5>
                <p class="card-text product__description">
                  {{ product.description }}
                </p>
                <button
                  @click="addProductToCart(product)"
                  class="btn btn-info product__add-to-cart"
                >
                  Add to cart
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapActions } from "vuex";
import BrandFilter from "../components/BrandFilter";
import { mapGetters } from "vuex";

export default {
  data() {
    return {
      searchText: "",
      sortBy: [
        { text: "None", value: 0, selected: true },
        { text: "Price: Low to High", value: 1 },
        { text: "Price: High to Low", value: 2 }
      ]
    };
  },
  computed: {
    ...mapGetters(["filterProducts"])
  },
  components: { BrandFilter },
  methods: {
    ...mapActions(["addProductToCart"]),
    onChange(event) {
      debugger;
      console.log(event.target.value);
      switch (event.target.value) {
        case "1":
          this.$store.commit("orderByPriceAsc");
          break;
        case "2":
          this.$store.commit("orderByPriceDesc");
          break;
        default:
        // code block
      }
    },
    search() {
      if (this.searchText.length <= 1) return;
      //console.log("search clicked" + this.searchText);
      this.$store.commit("searchText", this.searchText);
    }
  }
};
</script>

<style scoped lang="scss">
.top5 {
  margin-top: 5px;
}

.product {
  padding-bottom: 2rem;
  text-align: center;
  &__imgContainer {
    text-align: center;
  }
  &__img {
    width: 100%;
    height: 100%;
    text-align: center;
    &:focus {
      outline: none;
    }
  }
  &__text {
    flex: 0 0 40%;
  }
  &__link {
    flex: 0 0 65%;
    height: 60%;
    padding: 1rem;
    position: relative;
    cursor: pointer;
  }
  &__title {
    font-size: 0.8rem;
  }
  &__description {
    font-size: 0.7rem;
    overflow: hidden;
    text-overflow: ellipsis;
    display: -webkit-box;
    -webkit-line-clamp: 3; /* number of lines to show */
    -webkit-box-orient: vertical;
  }
  &:hover {
    box-shadow: 0 1rem 2rem rgba(0, 0, 0, 0.2);
  }
  &__add-to-cart {
    position: absolute;
    bottom: 0.8rem;
    width: 60%;
    left: 50%;
    opacity: 0;
    visibility: hidden;
    transform: translateX(-50%);
    transition: all 0.2s;
    padding: 3px 12px;
  }
  &:hover &__add-to-cart {
    visibility: visible;
    opacity: 1;
  }
  &:hover .owl-dots {
    display: inline-block;
  }
}
@media only screen and (max-width: 720px) {
  .product {
    height: auto !important;

    &__img {
      width: 50%;
      height: 50%;
      &:focus {
        outline: none;
      }
    }
    &__add-to-cart {
      visibility: visible;
      opacity: 1;
      font-size: 70%;
    }
    &__description {
      display: none;
    }
    & .owl-dots {
      display: inline-block;
    }
    &__title {
      overflow: hidden;
      text-overflow: ellipsis;
      display: -webkit-box;
      -webkit-line-clamp: 2; /* number of lines to show */
      -webkit-box-orient: vertical;
    }
    &__price {
      font-size: 80%;
    }
  }
}
</style>
